import { clientConfig, getSdk } from "@quickpoint.me/shared";
import type {
	SDK_GenerateLayoutMutation,
	SDK_GenerateLayoutMutationVariables,
} from "@quickpoint.me/shared";
import { GraphQLClient } from "graphql-request";

const client = new GraphQLClient(clientConfig.gqlLayoutAi());
const sdk = getSdk(client);

export type GenerateLayoutResult = SDK_GenerateLayoutMutation["generateLayout"];

export async function postAiData(
	variables: SDK_GenerateLayoutMutationVariables,
	jwt?: string,
): Promise<GenerateLayoutResult> {
	// the worker requires a valid session — sent as an Authorization header
	// since the mutation schema has no jwt field
	const headers = jwt ? { Authorization: `Bearer ${jwt}` } : undefined;
	const res = await sdk.GenerateLayout(variables, headers);
	return res.generateLayout;
}
